import { formatMoney } from './currency';

// Precio por unidad que paga el cliente (con el descuento ya aplicado).
const effectiveUnitPrice = (item) => {
  const quantity = Number(item.quantity) || 0;
  return quantity > 0 && item.totalPrice != null ? item.totalPrice / quantity : Number(item.unitPrice) || 0;
};

/**
 * Diferencias de ítems entre el documento original y el editado (productos agregados, quitados, y cambios de
 * cantidad o precio). Los ítems con cantidad 0 cuentan como quitados. Vacío si no cambió nada que le importe al cliente.
 */
export const diffOrderItems = (before, after) => {
  const group = (items) => {
    const map = new Map();
    items.filter((item) => Number(item.quantity) > 0).forEach((item) => {
      const prev = map.get(item.productId);
      map.set(item.productId, prev
        ? { ...prev, quantity: prev.quantity + item.quantity, totalPrice: (prev.totalPrice || 0) + (item.totalPrice || 0) }
        : { ...item });
    });
    return map;
  };
  const beforeMap = group(before);
  const afterMap = group(after);
  const changes = [];
  afterMap.forEach((item, productId) => {
    const old = beforeMap.get(productId);
    if (!old) {
      changes.push({ productId, productName: item.productName, type: 'ADDED', newQuantity: item.quantity, newUnitPrice: effectiveUnitPrice(item) });
      return;
    }
    const quantityChanged = old.quantity !== item.quantity;
    const priceChanged = Math.abs(effectiveUnitPrice(old) - effectiveUnitPrice(item)) > 0.005;
    if (quantityChanged || priceChanged) {
      changes.push({
        productId, productName: item.productName, type: 'CHANGED',
        previousQuantity: old.quantity, newQuantity: item.quantity,
        previousUnitPrice: effectiveUnitPrice(old), newUnitPrice: effectiveUnitPrice(item)
      });
    }
  });
  beforeMap.forEach((item, productId) => {
    if (!afterMap.has(productId)) {
      changes.push({ productId, productName: item.productName, type: 'REMOVED', previousQuantity: item.quantity, previousUnitPrice: effectiveUnitPrice(item) });
    }
  });
  return changes;
};

export const describeOrderChange = (change) => {
  switch (change.type) {
    case 'ADDED':
      return `Agregado: ${change.newQuantity} x ${formatMoney(change.newUnitPrice)}`;
    case 'REMOVED':
      return `Quitado (antes: ${change.previousQuantity} x ${formatMoney(change.previousUnitPrice)})`;
    default: {
      const parts = [];
      if (change.previousQuantity !== change.newQuantity) parts.push(`Cantidad: ${change.previousQuantity} → ${change.newQuantity}`);
      if (Math.abs(change.previousUnitPrice - change.newUnitPrice) > 0.005) {
        parts.push(`Precio: ${formatMoney(change.previousUnitPrice)} → ${formatMoney(change.newUnitPrice)}`);
      }
      return parts.join(' · ');
    }
  }
};
